import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { CalendarUtilityService } from "src/app/services/calendar-utility.service";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-reschedule-appointment",
  templateUrl: "./reschedule-appointment.component.html",
  styleUrls: ["./reschedule-appointment.component.scss"],
})
export class RescheduleAppointmentComponent implements OnInit, OnDestroy {
  leadId;
  localAppointmentId;
  isNewUser;
  callType;
  callerStatusAutoId;
  callerId;
  rescheduleDetails = [];
  selectedCallStatusId;
  selectedCallStatusName;
  initialFlag: boolean = true;
  rescheduleAppointmentForm: FormGroup;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  @Output() rescheduleDone: EventEmitter<any> = new EventEmitter<any>();
  selectedRescheduleDetails$: Subscription;


  constructor(
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private calendarService: CalendarUtilityService,
    private commonService: CommonService,
    private datePipe: DatePipe
  ) {}


  ngOnInit() {
    this.rescheduleAppointmentForm = this.formBuilder.group({
      appointmentDate: ["", Validators.required],
      appointmentSlot: ["", [Validators.required, Validators.min(1)]],
      statusRemarks: [""],
    });
    this.getAppointmentDetails();
  }

  ngOnDestroy(): void {
    this.selectedRescheduleDetails$.unsubscribe();
  }

  getAppointmentDetails() {
    debugger;
    this.selectedRescheduleDetails$ =
      this.callCenterService.selectedRescheduleDetails.subscribe((value) => {
        debugger;
        this.leadId = value.LeadId;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.callerStatusAutoId = value.CallerStatusAutoId;
        this.callerId = value.CallerId;
        debugger;
        this.rescheduleDetails = value.RescheduleDetails;
        this.localAppointmentId = this.rescheduleDetails["id"];
        this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
        this.selectedCallStatusName = value.CallStatus["statusName"];
        this.selectedHospital = this.rescheduleDetails["hospitalId"];
        this.selectedSpeciality = this.rescheduleDetails["specialty_IdStr"];
        this.selectedDoctor =
          this.rescheduleDetails["doctorId"] == "0"
            ? this.rescheduleDetails["doctor_IdStr"]
            : this.rescheduleDetails["doctorId"];
        this.selectedCity = this.rescheduleDetails["cityId"];
        this.previousApptDate = this.rescheduleDetails["appointmentDate"];
        //  this.selectedDate = this.rescheduleDetails['appointmentDate'].split(' ')[0];
        //let dd = this.selectedDate.includes('-') ?this.selectedDate.split('-') :this.selectedDate.split('/');
        // this.selectedDate = new Date(dd[1]+"-"+dd[0]+"-"+dd[2]);
        // this.rescheduleAppointmentForm.controls["appointmentDate"].setValue(new Date(this.selectedDate));
        this.getDates(this.selectedDoctor);
        //this.getSlots(this.selectedDate);
      });
  }
  selectedDate;
  previousApptDate;
  selectedHospital;
  selectedDoctor: any;
  selectedSpeciality;
  selectedCity;
  getDates(doctorId) {
    this.loadingFlag = true;
    this.selectedDoctor = doctorId;
    this.datesData = [];
    this.askApolloService
      .getDates(this.selectedHospital, doctorId) // hospitalid, doctorId
      .subscribe(
        (res: any) => {
          if (res && res.response.name) {
            this.disableApptDates(res.response.name);
          }
          this.loadingFlag = false;
        },
        (error) => {
          this.loadingFlag = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve dates data from server "
          );
        }
      );
  }

  datesData: any[];
  apptMaximumDate = new Date();
  apptMinimumDate = new Date();
  invalidApptDates: Date[];
  tempDates: Date[];
  disableApptDates(enableDates) {
    debugger;
    //enableDates = "2020-5-14,2020-5-18,2020-5-19,2020-5-20,2020-5-21,2020-5-25,2020-5-26,2020-5-27,2020-5-30,2020-6-1,2020-6-2,2020-6-3,2020-6-4,2020-6-5,2020-6-6,2020-6-11,2020-6-12,2020-6-13,2020-6-15,2020-6-16,2020-6-19,2020-6-20,2020-6-22,2020-6-23,2020-6-24,2020-6-25,2020-6-26,2020-6-27,2020-6-29,2020-6-30,2020-7-1,2020-7-2,2020-7-3,2020-7-4,2020-7-6,2020-7-7,2020-7-8,2020-7-9,2020-7-10,2020-7-11,2020-7-13,2020-7-14,2020-7-15,2020-7-16,2020-7-17,2020-7-18,2020-7-20,2020-7-21,2020-7-22,2020-7-23,2020-7-24,2020-7-25,2020-7-27,2020-7-28,2020-7-29,2020-7-30,2020-7-31,2020-8-1,2020-8-3,2020-8-4,2020-8-5,2020-8-6,2020-8-7,2020-8-8,2020-8-14,2020-8-15,2020-8-17,2020-8-18,2020-8-19,2020-8-20,2020-8-21,2020-8-22,2020-8-24,2020-8-29,2020-8-31";
    this.invalidApptDates = [];
    this.apptMaximumDate = new Date();
    this.apptMinimumDate = new Date();
    this.datesData = enableDates ? enableDates.split(",") : [];
    if (this.datesData.length > 0) {
      debugger;
      this.datesData.sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );
      this.apptMaximumDate = new Date(
        this.parseDateFromDDMMYYYY(this.datesData[this.datesData.length - 1])
      );
      this.apptMinimumDate = new Date(
        this.parseDateFromDDMMYYYY(this.datesData[0])
      );
      this.tempDates = [];
      this.datesData.forEach((d) => {
        this.tempDates.push(new Date(d));
      });

      this.invalidApptDates = this.calendarService.getDisabledDates(
        this.tempDates
      );

      //this.ref.detectChanges();
    } else {
      this.invalidApptDates = [];
    }
  }


  parseDateFromDDMMYYYY(dateStr) {
    console.log("Original date string:", dateStr);

    if (!dateStr) {
      console.log("Date string is undefined or empty");
      return null; // For PrimeNG calendar, null is acceptable and keeps it editable
    }

    try {
      // Handle different possible formats
      let datePart = dateStr;

      // If the date contains time part (like "12/17/2024 12:00:00 AM")
      if (dateStr.includes(" ")) {
        datePart = dateStr.split(" ")[0];
      }

      console.log("Date part extracted:", datePart);

      // Check if using "/" or "-" as separator
      let separator = datePart.includes("/") ? "/" : "-";
       const parts1 = datePart.split(separator);
       let parsedDate = datePart;
       if(parts1[0].length == 4){
         parsedDate = new Date(datePart);
         datePart = this.datePipe.transform(parsedDate, 'dd-MM-yyyy');
       }

     // let parsedDate = new Date(datePart);
      
      // Split the date parts
      const parts = datePart.split(separator);
      console.log("Date parts:", parts);

      if (parts.length !== 3) {
        console.log("Invalid date format - doesn't have 3 parts");
        return null;
      }

      // Determine which format we're dealing with (DD/MM/YYYY or MM/DD/YYYY)
      let day, month, year;

      // API seems to be using MM/DD/YYYY format
      month = parseInt(parts[1]);
      day = parseInt(parts[0]);
      year = parseInt(parts[2]);

      console.log(`Parsed date: day=${day}, month=${month}, year=${year}`);

      // Create and validate the date
      const date = new Date(year, month - 1, day);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.log("Invalid date created");
        return null;
      }

      console.log("Final parsed date:", date);
      return date;
    } catch (error) {
      console.error("Error parsing date:", error);
      return null;
    }
  }

  slotsData;
  allSlotsData = [];
  loadingFlag: boolean = false;
  getSlots(apptDate) {
    this.loadingFlag = true;
    this.allSlotsData = [];
    this.rescheduleAppointmentForm.get("appointmentSlot").setValue("");
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = dd.getMonth() + 1 + "";
    let year = dd.getFullYear();
    apptDate =
      (date.length == 1 ? "0" + date : date) +
      "-" +
      (month.length == 1 ? "0" + month : month) +
      "-" +
      year;
    this.askApolloService
      .getSlots(
        +this.selectedHospital,
        this.selectedDoctor,
        +this.selectedSpeciality,
        apptDate,
        ""
      ) // hospitalid, doctorId, specid, appt date
      .subscribe(
        (res: any) => {
          debugger;
          this.slotsData = res.response;
          this.allSlotsData = res.response;
          // if(this.slotsData["morningSlotTime"] && this.slotsData["morningSlotTime"].length > 0 ){
          //   this.allSlotsData =this.allSlotsData.concat(this.slotsData["morningSlotTime"]);
          // }
          // if(this.slotsData["afternoonSlotTime"] && this.slotsData["afternoonSlotTime"].length > 0 ){
          //   this.allSlotsData =this.allSlotsData.concat(this.slotsData["afternoonSlotTime"])
          // }
          // if(this.slotsData["eveningSlotTime"] && this.slotsData["eveningSlotTime"].length > 0 ){
          //   this.allSlotsData =this.allSlotsData.concat(this.slotsData["eveningSlotTime"])
          // }
          // if(this.slotsData["nightSlottTime"] && this.slotsData["nightSlottTime"].length > 0 ){
          //   this.allSlotsData =this.allSlotsData.concat(this.slotsData["nightSlottTime"])
          // }
          if (this.allSlotsData.length == 0) {
            this.messageService.showErrorMessage(
              "No slots available on selected date."
            );
          }
          this.loadingFlag = false;
        },
        (error) => {
          this.loadingFlag = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve slots data from server "
          );
        }
      );
  }

  changeAskApolloDateFormatDDMMYYYY(givenDate) {
    let d = givenDate.split(" ")[0];
    return d.replaceAll("-", "/");
  }

  RescheduleAppointment() {
    /** check form */
    let formDataValues = this.rescheduleAppointmentForm.value;
    let slotObj = this.allSlotsData.find(
      (o) => o.slotId == formDataValues.appointmentSlot
    );
    debugger;

    let payload = {
      localAppointmentId: this.localAppointmentId,
      askApolloAppointmentId: +this.rescheduleDetails["askApolloAppointmentId"],
      appointmentAutoId: this.rescheduleDetails["appointmentAutoId"]
        ? this.rescheduleDetails["appointmentAutoId"]
        : -1,
      rescheduleSlotIdFrom: this.rescheduleDetails["slotId"],
      rescheduleSlotTimeFrom: this.rescheduleDetails["slotTime"],
      rescheduleFrom: this.changeAskApolloDateFormatDDMMYYYY(
        this.previousApptDate
      ),
      slotId: slotObj.slotId,
      slotTime: slotObj.timeSlot,
      appointmentDate: CommonMethods.changeDateFormatDDMMYYYY(
        formDataValues.appointmentDate
      ),
      modifiedBy: 0,
      modifiedIp: "",
      CallerAutoId: +this.callerStatusAutoId ? this.callerStatusAutoId : 0,
      CallerId: this.callerId,
      CallStatusId: +this.selectedCallStatusId,
      StatusRemarks: formDataValues.statusRemarks,
      IsActivityLead:
        localStorage.getItem("IsActivityLead") == "true" ? true : false,
      CityId: this.selectedCity,
      SpecialtyId: this.selectedSpeciality,
      DoctorId: this.selectedDoctor,
      HospitalId: this.selectedHospital,
    };
    this.loadingFlag = true;
    this.askApolloService.RescheduleAppointment(payload).subscribe(
      (res: any) => {
        this.loadingFlag = false;
        if (res.response !== null && ((res.response.result !== undefined && res.response.result.statusCode >0 )||(res.response.result == undefined && res.response.statusCode >0 ))) {
          this.callCenterService.afterCompleteOperationKnowTheStatus({
            callStatusId: this.selectedCallStatusId,
            callStatusName: this.selectedCallStatusName,
            isOperationDone: true,
            statusMessage: "Reschedule Appointment Successfully.",
          });
          this.rescheduleDone.emit();
          this.messageService.showSuccess(res.response.result? res.response.result.statusMessage : res.response.statusMessage);
        } else {
          this.messageService.showErrorMessage(
            res.response.result? res.response.result.statusMessage : res.response.statusMessage
          );
        }
      },
      (error) => {
        this.loadingFlag = false;
        this.messageService.showErrorMessage(
          "Unable to reschedule Appt, An error occur while rescheduling Appt."
        );
      }
    );
  }
}
